import { Box, ButtonBase, Tooltip } from "@mui/material";
import React from "react";
import Iconify from "../../components/iconify/Iconify";
import OrderMoreOptionsMenu from "./OrderMoreOptionsMenu";

function OrderActionsNonCounter({
  isKOTValid,
  isSaveValid,
  activeOrderId,
  onKOTClick,
  onKOTPrintClick,
  onHoldClick,
  onPrintClick,
  onSettleClick,
  anchorEl,
  open,
  onOpenMenu,
  onCloseMenu,
  isLoading,
  onActivityClick,
}) {
  return (
    <Box className="menu-item-btn-wrap">
      <Box className="order-actions-bar">
        <ButtonBase
          className="order-btn"
          sx={{
            maxWidth: "50px",
            opacity: !isKOTValid ? 0.4 : 1,
            cursor: !isKOTValid ? "not-allowed" : "pointer",
            pointerEvents: !isKOTValid ? "none" : "auto",
          }}
          onClick={onKOTClick}
          disabled={!isKOTValid || isLoading}
        >
          KOT
        </ButtonBase>

        <ButtonBase
          className="order-btn"
          sx={{
            opacity: !isKOTValid ? 0.4 : 1,
            cursor: !isKOTValid ? "not-allowed" : "pointer",
            pointerEvents: !isKOTValid ? "none" : "auto",
          }}
          onClick={onKOTPrintClick}
          disabled={!isKOTValid || isLoading}
        >
          KOT & Print
        </ButtonBase>

        <ButtonBase
          className="order-btn hold"
          sx={{
            maxWidth: "58px",
            opacity: !isSaveValid ? 0.4 : 1,
            cursor: !isSaveValid ? "not-allowed" : "pointer",
            pointerEvents: !isSaveValid ? "none" : "auto",
          }}
          onClick={onHoldClick}
          disabled={!isSaveValid || isLoading}
        >
          Hold
        </ButtonBase>

        <ButtonBase
          className="order-btn print"
          sx={{
            opacity: !isSaveValid ? 0.4 : 1,
            cursor: !isSaveValid ? "not-allowed" : "pointer",
            pointerEvents: !isSaveValid ? "none" : "auto",
          }}
          onClick={onPrintClick}
          disabled={!isSaveValid || isLoading}
        >
          Print Bill
        </ButtonBase>

        <ButtonBase
          className="order-btn settle"
          sx={{
            maxWidth: "65px",
            opacity: !activeOrderId ? 0.4 : 1,
            cursor: !activeOrderId ? "not-allowed" : "pointer",
            pointerEvents: !activeOrderId ? "none" : "auto",
          }}
          onClick={onSettleClick}
          disabled={!activeOrderId}
        >
          Settle
        </ButtonBase>

        <Tooltip title="More options">
          <ButtonBase className="order-btn more" onClick={onOpenMenu}>
            <Iconify icon="mdi:dots-vertical" />
          </ButtonBase>
        </Tooltip>

        {/* More Menu */}
        <OrderMoreOptionsMenu
          anchorEl={anchorEl}
          open={open}
          onClose={onCloseMenu}
          activeOrderId={activeOrderId}
          onActivityClick={onActivityClick}
        />
      </Box>
    </Box>
  );
}

export default OrderActionsNonCounter;
